import { forwardRef } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@/lib/utils';

export const Label = forwardRef(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      'text-xs font-medium uppercase tracking-wider text-muted-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      className
    )}
    {...props}
  />
));
Label.displayName = 'Label';

export const RequiredLabel = forwardRef(({ className, children, ...props }, ref) => (
  <Label ref={ref} className={className} {...props}>
    {children}
    {' '}
    <span className="text-destructive" aria-label="required" title="obrigatório">
      *
    </span>
  </Label>
));
RequiredLabel.displayName = 'RequiredLabel';
